import ActionTypes from "../../../constants";
import { BusinessPartnerReducerType } from "../types";

const initialState: BusinessPartnerReducerType = {
  bpTypes: null,
  countries: null,
  currencyRefs: null,
  targetSystems: null,
  cities: null,
  postalCodes: null,
  duplicateBPs: null,
  languages: null,
  cityCreated: null,
  poBoxCityCreated: null,
  bpCreated: false,
  bpUpdated: false,
  selectedBP: null,
  stateProvinces: null,
  cityUpdated: false,
  postalCodeCreated: null,
  poBoxCityUpdated: null,
  poBoxPostalCodeCreated: null,
  poBoxPostalCodeUpdated: null,
  banks: null,
  resetPostalCodeUPdatedFlag: false,
  statuses: null,
  bpRejected: false,
  duplicateBPPagination: {
    currentPage: 1,
    pageSize: 15,
    totalRecords: 0,
  },
  deleteBPSucceeded: false,
  bpActivated: false,
  bpActions: null,
  pseudoRoleMap: null,
  pseudoroleValueCodeMap: null,
  bicSwifts: null,
  bankBranch: null,
};

const businessPartner = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_LOOKUP_SUCCEEDED: {
      const { lookup } = action;
      const bpTypes = lookup.bpType;
      const pseudoroleValueCodeMap = new Map();
      bpTypes.forEach((bpType) => {
        pseudoroleValueCodeMap.set(bpType.coId, bpType.coValue);
      });
      const countries = lookup.countries;
      const currencyRefs = lookup.currencyRef;
      const targetSystems = lookup.targetSystem;
      const languages = lookup.language;
      const banks = lookup.banks;
      const statuses = lookup.status;
      const bpActions = lookup.action;
      const pseudoRoleMap = lookup.pseudoRoleMap;
      return {
        ...state,
        bpTypes,
        countries,
        currencyRefs,
        targetSystems,
        languages,
        banks,
        statuses,
        bpActions,
        pseudoRoleMap,
        pseudoroleValueCodeMap,
      };
    }
    case ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY_SUCCEEDED: {
      const { cities, postalCodes, stateProvinces } = action;
      return { ...state, cities, postalCodes, stateProvinces };
    }
    case ActionTypes.FLUSH_COUNTRY_DEPENDENT_LOOKUP_DATA: {
      return {
        ...state,
        cities: null,
        postalCodes: null,
        stateProvinces: null,
      };
    }
    case ActionTypes.CHECK_DUBPLICATE_OF_SUCCEEDED: {
      const { duplicateBPs, paginationInfo: duplicateBPPagination } = action;
      return {
        ...state,
        duplicateBPs: duplicateBPs.length > 0 ? duplicateBPs : null,
        duplicateBPPagination,
      };
    }
    case ActionTypes.RESET_DUPLICATE_BPS: {
      return { ...state, duplicateBPs: null };
    }
    case ActionTypes.DELETE_DUPLICATE_BP_SUCCEEDED: {
      const { deletedBPID } = action;
      const duplicateBPs = state.duplicateBPs.filter(
        (item) => item.bpId !== deletedBPID
      );
      return { ...state, duplicateBPDeleted: true, duplicateBPs };
    }
    case ActionTypes.RESET_DUPLICATE_BP_DELETED_FLAG: {
      return { ...state, duplicateBPDeleted: false };
    }
    case ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER_SUCCEEDED: {
      return { ...state, selectedBP: action.retainedData };
    }
    case ActionTypes.CREATE_CITY_SUCCEEDED: {
      const { city } = action;
      const cities = state.cities.concat(city);
      return { ...state, cities, cityCreated: city.ciId };
    }
    case ActionTypes.CREATE_POBOX_CITY_SUCCEEDED: {
      const { city } = action;
      const cities = state.cities.concat(city);
      return { ...state, cities, poBoxCityCreated: city.ciId };
    }

    case ActionTypes.RESET_CITY_CREATED_FLAG: {
      // reset both city as well as pobox city created flag
      return { ...state, cityCreated: null, poBoxCityCreated: null };
    }
    case ActionTypes.UPDATE_CITY_SUCCEEDED: {
      const { city } = action;
      const cities = state.cities.map((item) =>
        item.ciId === city.ciId ? city : item
      );
      return { ...state, cities, cityUpdated: true };
    }
    case ActionTypes.UPDATE_POBOX_CITY_SUCCEEDED: {
      const { city } = action;
      const cities = state.cities.map((item) =>
        item.ciId === city.ciId ? city : item
      );
      return { ...state, cities, poBoxCityUpdated: true };
    }
    case ActionTypes.RESET_CITY_UPDATED_FLAG: {
      return { ...state, cityUpdated: false, poBoxCityUpdated: false };
    }
    case ActionTypes.CREATE_BUSINESS_PARTNER_SUCCEEDED: {
      return {
        ...state,
        bpCreated: true,
        selectedBP: null,
        bicSwifts: null,
        bankBranch: null,
      };
    }
    case ActionTypes.RESET_BP_CRREATED_FLAG: {
      return { ...state, bpCreated: false };
    }
    case ActionTypes.UPDATE_BUSINESS_PARTNER_SUCCEEDED: {
      const { status } = action;
      switch (status) {
        case 6: {
          return { ...state, bpActivated: true };
        }
        case 5: {
          return { ...state, bpRejected: true };
        }
        default: {
          return { ...state, bpUpdated: true };
        }
      }
    }
    case ActionTypes.RESET_BP_UPDATED_FLAG: {
      if (state.bpRejected || state.bpActivated) {
        return {
          ...state,
          bpUpdated: false,
          bpActivated: false,
          bpRejected: false,
          selectedBP: null,
        };
      }
      return {
        ...state,
        bpUpdated: false,
        bpActivated: false,
        bpRejected: false,
      };
    }
    case ActionTypes.SET_SELECTED_BP: {
      const { selectedBP } = action;
      return { ...state, selectedBP: { ...selectedBP } };
    }
    case ActionTypes.CREATE_POSTAL_CODE_SUCCEEDED: {
      const { postalCode } = action;
      const postalCodes = state.postalCodes.concat(postalCode);
      return { ...state, postalCodes, postalCodeCreated: postalCode.pcId };
    }
    case ActionTypes.CREATE_POBOX_POSTAL_CODE_SUCCEEDED: {
      const { postalCode } = action;
      const postalCodes = state.postalCodes.concat(postalCode);
      return { ...state, postalCodes, poBoxPostalCodeCreated: postalCode.pcId };
    }
    case ActionTypes.RESET_POSTAL_CODE_CREATED_FLAG: {
      return {
        ...state,
        postalCodeCreated: null,
        poBoxPostalCodeCreated: null,
      };
    }
    case ActionTypes.UPDATE_POSTAL_CODE_SUCCEEDED: {
      const { postalCode } = action;
      const postalCodes = state.postalCodes.map((item) =>
        item.pcId === postalCode.pcId ? postalCode : item
      );
      return { ...state, postalCodes, postalCodeUpdated: true };
    }
    case ActionTypes.UPDATE_POBOX_POSTAL_CODE_SUCCEEDED: {
      const { postalCode } = action;
      const postalCodes = state.postalCodes.map((item) =>
        item.pcId === postalCode.pcId ? postalCode : item
      );
      return { ...state, postalCodes, poBoxPostalCodeUpdated: true };
    }
    case ActionTypes.RESET_POSTAL_CODE_UPDATED_FLAG: {
      return {
        ...state,
        postalCodeUpdated: false,
        poBoxPostalCodeUpdated: null,
      };
    }
    case ActionTypes.RESET_SELECTED_BP: {
      return { ...state, selectedBP: null, bankBranch: null };
    }
    case ActionTypes.DELETE_BUSINESS_PARTNER_SUCCEEDED: {
      return { ...state, selectedBP: null, deleteBPSucceeded: true };
    }
    case ActionTypes.RESET_DELETE_BP_SUCCEEDED: {
      return { ...state, deleteBPSucceeded: false };
    }
    case ActionTypes.FETCH_BIC_SWIFTS_SUCCEEDED: {
      const { bicSwifts } = action;

      return { ...state, bicSwifts };
    }
    case ActionTypes.RESET_BIC_SWIFTS: {
      return { ...state, bicSwifts: [] };
    }
    case ActionTypes.FETCH_BANK_BRANCH_SUCCEEDED: {
      const { bankBranch } = action;
      return { ...state, bankBranch };
    }
    case ActionTypes.RESET_BANK_BRANCH: {
      return { ...state, bankBranch: null };
    }

    default: {
      return state;
    }
  }
};
export default businessPartner;
